// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610131327/js/" + chunkId + "." + {"44":"4b2cf1ed","225":"70bff710","481":"6107161e","486":"fb2a8763","770":"d85bdf03"}[chunkId] + ".0.8335197458181092.chunk.js";
};